import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgXCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(1.2504 1.2504)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5ZM15.2803 7.28027L11.8105 10.75L15.2803 14.2197L14.2197 15.2803L10.75 11.8105L7.28027 15.2803L6.21973 14.2197L9.68945 10.75L6.21973 7.28027L7.28027 6.21973L10.75 9.68945L14.2197 6.21973L15.2803 7.28027Z",
			fill: "currentColor"
		})
	})
});
export default SvgXCircle;
